module.exports = __webpack_public_path__ + "img/TSY_03_01.38f257f5.png";